export default __webpack_public_path__ + "static/media/431.19106e7a.jpg";